<template>
  <v-card>
    <v-card-text>
      <v-btn color="primary" @click="showModal = true">Help</v-btn>
    </v-card-text>
    <v-dialog v-model="showModal" max-width="750px">
      <v-card>
        <v-card-text>
          <p>
            1. Select the system/s you want to request permissions for in the 'Systems access'
            section. You may request access for multiple services in one request.
          </p>
          <p>
            2. Select the permissions you require for each system. You do not need to re-select
            permissions you already possess.
          </p>
          <p>
            3. Click 'next' to view the list of possible approvers. The people that appear on this
            list is determined by the permissions you have requested; only those that can approve
            your request will be listed. If no-one is listed, or your desired approver does not
            appear, you may wish to go back and change the list of permissions in the request.
          </p>
          <p>
            Select from the list who should approve the request. Those people selected will be
            notified when you submit, then view and approve your request.
          </p>
          <div class="rule"></div>
          <p>
            Your approval may be approved or rejected by any of the specified approvers (only 1 is
            required). If approved, you will be notified and your permissions automatically
            updated per the approval request.
          </p>
          <p>
            You may cancel your request at any time before it is approved or rejected.
          </p>
          <v-btn @click="showModal = false">Close</v-btn>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
  export default {
    data() {
      return {
        showModal: false
      };
    }
  };
</script>

<style lang="less" scoped>
  @import '../../../style/form.less'; // For '.rule'

  p {
    text-align: left;
  }
</style>
